/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEvent } from '../../models/calendar-event';
import { CalendarEventNew } from '../../models/calendar-event-new';

export interface CreateCalendarEvent$Params {
      body: CalendarEventNew
}

export function createCalendarEvent(http: HttpClient, rootUrl: string, params: CreateCalendarEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEvent>> {
  const rb = new RequestBuilder(rootUrl, createCalendarEvent.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEvent>;
    })
  );
}

createCalendarEvent.PATH = '/api/v1/calendars/default/events';
